/* global bocAmchart */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.postProcessValetSeries = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doPostProcessValetSeries(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 * Produces and returns an array of data based on the valet data for the data with series with values,
 * uses series: {seriesLabel}, value: {value} elements as used by pie chart
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doPostProcessValetSeries = function (data, dataLoader, chart) {
    var output,
        seriesDetails,
        series,
        seriesLabel,
        seriesSet;

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running postProcessValetSeries, inputs:",
            data
        );
    }

    // Try to detect dimensions first
    var dimensions = [];
    var dimension = false;

    for (series in data.seriesDetail) {
        if (data.seriesDetail.hasOwnProperty(series)) {
            seriesDetails = data.seriesDetail[series];
            if (seriesDetails.hasOwnProperty("dimension") && seriesDetails.dimension.hasOwnProperty("key")) {
                if (dimensions.indexOf(seriesDetails.dimension.key) === -1) {
                    dimensions.push(seriesDetails.dimension.key);
                }
            }
        }
    }

    if (dimensions.length > 0) {
        dimension = dimensions[0];
        if (dimensions.length > 1) {
            // eslint-disable-next-line no-console
            console.warn("Data error, more than one dimension found in one data set.");
        }
    }

    if (dimension === 'd') {
        dimension = false;
    }

    output = [];
    seriesSet = [];

    // Loop through all the observations, get all the series
    // Later observations containing same series will overwrite previous data

    data.observations.forEach(function (obs) {
        if (dimension && obs.hasOwnProperty(dimension)) {
            // Set the category values based on dimension, make sure the value is string
            var category = obs[dimension];
            if (!isNaN(category)) {
                category += " ";
            }

            // Looping through series, and find an observation for each of them
            for (series in data.seriesDetail) {
                if (data.seriesDetail.hasOwnProperty(series)) {

                    // Initialize the container for values of series for specific category
                    if (obs.hasOwnProperty(series)) {
                        seriesSet[category] = {
                            'series': category,
                            'value': obs[series].v
                        };
                    }
                }
            }
        } else {
            // Looping through series, and find an observation for each of them
            for (series in data.seriesDetail) {

                // property is either date or series name, ignoring the date field for now
                if (data.seriesDetail.hasOwnProperty(series) && obs.hasOwnProperty(series)) {
                    seriesDetails = data.seriesDetail[series];
                    var seriesLabels = seriesDetails.label.split('_');

                    if (chart.bocSettings.args.hasOwnProperty('labelindex')
                        && chart.bocSettings.args.labelindex < seriesLabels.length) {
                        seriesLabel = seriesLabels[chart.bocSettings.args.labelindex];
                    } else {
                        seriesLabel = seriesLabels[0];
                    }

                    seriesSet[series] = {
                        'series': seriesLabel,
                        'value': obs[series].v
                    };
                }
            }
        }
    });

    for (series in seriesSet) {
        output.push(seriesSet[series]);
    }

    bocAmchart.getChartTitlesFromGroup(data, chart);

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, output);
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data after postProcessValetSeries:",
            output
        );
    }

    return output;
};
